import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { selectActiveCompanyId } from "../../../redux/features/user/selectors/userState.selectors";
import { getEventDeliveryLogDetail } from "../actions/getEventDeliveryLogDetail";

export const EVENT_DELIVERY_LOG_DETAIL_QUERY_KEY = "event-delivery-log-detail";

export const useGetEventDeliveryLogDetail = (logUid: string | null) => {
  const companyId = useSelector(selectActiveCompanyId);

  return useQuery({
    queryKey: [EVENT_DELIVERY_LOG_DETAIL_QUERY_KEY, companyId, logUid],
    queryFn: () => getEventDeliveryLogDetail(logUid as string),
    enabled: Boolean(companyId) && Boolean(logUid),
  });
};
